import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "mt-40 flex justify-between flex-col lg:flex-row gap-5 w-full max-w-7xl relative pb-20 px-5 lg:px-10" }

import SocialLinks from "@/views/HomeView/SocialLinks"
import NameHeading from "@/views/HomeView/NameHeading"
import ProjectGallery from "@/views/HomeView/ProjectGallery"
import RightDecoration from "@/views/HomeView/RightDecoration.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NameHeading)),
      _createVNode(_unref(SocialLinks), { class: "self-start" }),
      _createVNode(RightDecoration, { class: "absolute -right-52 lg:-right-24 -bottom-10 z-[1]" })
    ]),
    _createVNode(_unref(ProjectGallery))
  ]))
}
}

})